import { render } from "./PrintHotelVoucher.vue?vue&type=template&id=ff78f660&scoped=true"
import script from "./PrintHotelVoucher.vue?vue&type=script&lang=js"
export * from "./PrintHotelVoucher.vue?vue&type=script&lang=js"

import "./PrintHotelVoucher.vue?vue&type=style&index=0&id=ff78f660&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff78f660"

export default script